// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueSweetAlert from 'vue-sweetalert'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueQrcodeReader from 'vue-qrcode-reader'
import VueQRCodeComponent from 'vue-qrcode-component'
import 'swiper/dist/css/swiper.css'

Vue.use(Vuetify)
Vue.use(VueSweetAlert)
Vue.use(VueAxios, axios)
Vue.use(VueCookies)
Vue.use(VueQrcodeReader)
Vue.use(VueAwesomeSwiper)
Vue.component('qr-code', VueQRCodeComponent)

window.$ = window.jQuery = require('jquery')

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js